const TIPOS_IMPORTACAO_DISPONIVEIS_V2 = ['RAZAO']

function normalizarValor(valor) {
  return String(valor || '').trim().toUpperCase()
}

export function filtrarTiposImportacaoDisponiveisV2(tipos = []) {
  return tipos.filter((tipo) => {
    const identificador = normalizarValor(tipo.tipo || tipo.tipos_importacoes?.tipo)
    const descricao = normalizarValor(tipo.descricao)

    return TIPOS_IMPORTACAO_DISPONIVEIS_V2.includes(identificador) || descricao === 'BASE DE OBRAS'
  })
}
